import { AssetUploadForm } from '@/components/admin/asset-upload';
import { ASSET_ACCEPT } from '@/lib/ambiance-labels';
import { Dialog } from '@pms-digital/design-system';
import { MEDIATHEQUE_UPLOAD_DIALOG_TESTID } from './contracts';

/**
 * « Ajouter un fichier » (issue #121): a small form in a modal, the `Dialog` of
 * the design system, and NOT `versioned-dialog.tsx` - that shell puts the focus
 * on « Annuler » because its three boxes SHOW AN EFFECT before it happens,
 * where this one's first gesture is picking a file. The package box takes the
 * focus inside on opening, closes on Escape (`onOpenChange`) and gives the
 * focus back to « Ajouter un fichier » when it goes.
 *
 * `AssetUploadForm` is mounted as-is - it already carries the uncontrolled
 * fields, the covered file input and the French refusal line; this file only
 * gives it a title and the wide `ASSET_ACCEPT.all` accept list, since the
 * library takes both natures. The `Dialog` takes no `data-testid`, so the mark
 * of the box rides on the envelope of its content: mounted exactly while the
 * box is open.
 */

export interface MediathequeUploadDialogProps {
  busy: boolean;
  /** The French of the last refusal, worded from its code; null when none. */
  refusal: string | null;
  onUpload: (file: File, license: string, tags: string) => void;
  onCancel: () => void;
}

export function MediathequeUploadDialog({
  busy,
  refusal,
  onUpload,
  onCancel,
}: MediathequeUploadDialogProps) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
      size="form"
      title="Ajouter un fichier"
      description="Une image ou un son, pour la médiathèque : la licence et les mots-clés restent facultatifs."
    >
      <div data-testid={MEDIATHEQUE_UPLOAD_DIALOG_TESTID}>
        <AssetUploadForm
          busy={busy}
          accept={ASSET_ACCEPT.all}
          refusal={refusal}
          onUpload={onUpload}
          onCancel={onCancel}
        />
      </div>
    </Dialog>
  );
}
